import type { Playtest } from '@playerbase/types';

import { PlaytestRow } from './playtest-row.js';

interface PlaytestsListProps {
  rows: Playtest[];
}

export function PlaytestsList({ rows }: PlaytestsListProps): JSX.Element {
  return (
    <ul className="flex flex-col divide-y divide-border rounded-md border border-border bg-surface-2">
      {rows.map((playtest) => (
        <PlaytestRow key={playtest.id} playtest={playtest} />
      ))}
    </ul>
  );
}
